export default "__VITE_ASSET__cd99eff4__"